import moment from 'moment';
import _partition from 'lodash/partition';
import { naturalSortByKey } from '@bringg-frontend/utils';

import DeliveryBlock from './stores/domain-objects/delivery-block';
import type Driver from '../../stores/drivers/domain-object/driver';
import { DeliveryTimes } from './modal/delivery-block-modal';
import { deliveryBlocksRootStore } from './stores/delivery-blocks-root-store';

export const checkRequestedTimeConflictsWithBlock = (
	{ start_time, end_time }: DeliveryBlock,
	startTimeToCheck: string,
	endTimeToCheck: string
): boolean => {
	return (
		moment(startTimeToCheck).isBetween(start_time, end_time, null, '[]') ||
		moment(endTimeToCheck).isBetween(start_time, end_time, null, '[]') ||
		(moment(start_time).isBetween(startTimeToCheck, endTimeToCheck, null, '[]') &&
			moment(end_time).isBetween(startTimeToCheck, endTimeToCheck, null, '[]'))
	);
};

export const getSortedDriversByAvailabilityAndName = (
	drivers: Driver[],
	deliveryBlockTimes: DeliveryTimes,
	deliveryBlockId: number
): Driver[] => {
	const dividedDriversByAvailability = _partition(drivers, driver => {
		const { startTime, endTime } = deliveryBlockTimes;
		return isDriverAvailableAtRequestedBlock(driver.id, startTime, endTime, [deliveryBlockId]);
	});
	const sortedDrivers = dividedDriversByAvailability.map(_drivers => {
		return naturalSortByKey(_drivers, 'name');
	});

	return sortedDrivers.flat();
};

export function isDriverAvailableAtRequestedBlock(
	driverId: number,
	startTimeToCheck: string,
	endTimeToCheck: string,
	ignoreDeliveryBlockIds: number[] = [],
	teamId?: number
): boolean {
	return !findConflictedBlockWithRequestedTime(
		driverId,
		startTimeToCheck,
		endTimeToCheck,
		ignoreDeliveryBlockIds,
		teamId
	);
}

export function findConflictedBlockWithRequestedTime(
	driverId: number,
	startTimeToCheck: string,
	endTimeToCheck: string,
	ignoreDeliveryBlockIds: number[] = [],
	teamId?: number
): DeliveryBlock {
	const assignedDeliveryBlocks = deliveryBlocksRootStore.getStore().deliveryBlocksStore.allByDriver(driverId, teamId);
	return assignedDeliveryBlocks
		.filter(({ id }) => !ignoreDeliveryBlockIds.includes(id))
		.find(deliveryBlock => checkRequestedTimeConflictsWithBlock(deliveryBlock, startTimeToCheck, endTimeToCheck));
}
